import { computed } from 'vue';
import tinycolor from 'tinycolor2';
import { useTheme } from '../../compositions/component-lib.esm7.js';

/**
 * Take the theme button colors and turn them into usable colors
 * @param {Boolean} param0 noTransparency
 * @returns {Object} backgroundColor, color
 */
function useBtnColors() {
  let {
    noTransparency = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const theme = useTheme();
  const isHollowBtn = computed(() => {
    return theme.value.profile.btnStyle === 'hollow';
  });
  const hasTransparentBg = computed(() => {
    return tinycolor(theme.value.profile.btnBgColor).getAlpha() <= (noTransparency ? 0.95 : 0);
  });
  const backgroundColor = computed(() => {
    const btnBgColor = theme.value.profile.btnBgColor;

    // Hollow buttons use the text color as the background color
    if (isHollowBtn.value) {
      return theme.value.profile.btnColor;
    }
    if (hasTransparentBg.value) {
      return tinycolor(btnBgColor).setAlpha(1).toRgbString();
    }
    return btnBgColor;
  });
  const color = computed(() => {
    // If the background color has stayed the same, we don't need to change the text color
    if (backgroundColor.value === theme.value.profile.btnBgColor && !isHollowBtn.value) return theme.value.profile.btnColor;
    return tinycolor.mostReadable(backgroundColor.value, ['#fff', '#000'], {
      includeFallbackColors: true
    }).toRgbString();
  });
  return {
    backgroundColor,
    color
  };
}
export { useBtnColors };